<template>
    <v-layout pa-0 ma-0 row justify-space-between v-if="device && device.state">
        <v-flex xs6 class="d-inline-flex align-center">
            <div v-if="showLocation" class="note-row text-left ma-0"> {{device.location}} </div>
        </v-flex>
        <v-flex xs6 class="d-inline-flex justify-end align-center">
            <v-tooltip
                top
                content-class="arrow-down"
                v-model="showBattery"
                v-if="device.power == 'battery' && device.state.battery != null"
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        class="d-inline-flex"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop.prevent="showBattery = true"
                    >
                        <v-img max-height="24px" max-width="24px" :src="require(`@/assets/icons/${power}.svg`)"></v-img>
                    </div>
                </template>
                <span class="main-text">{{device.state.battery}}%</span>
            </v-tooltip>
            <v-img
                v-else-if="device.power == 'mains'"
                max-height="20px"
                max-width="20px"
                :src="require(`@/assets/icons/plug.svg`)"
            ></v-img>
            <v-tooltip top content-class="arrow-down" v-model="show">
                <template v-slot:activator="{ on, attrs }">
                    <div
                        class="d-inline-flex"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop.prevent="show = true"
                    >
                        <div class="status-marker ml-2">
                            <div :class="device.online ? 'green-color' : 'red-color'"></div>
                        </div>
                    </div>
                </template>
                <span class="main-text">{{device.online ? "online" : "offline"}}</span>
            </v-tooltip>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: "DeviceStatus",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            show: false,
            showBattery: false,
        };
    },
    computed: {
        power() {
            if (this.device.state && this.device.power && this.device.power == "battery") {
                return this.device.state.battery < 21 ?
                    "battery_empty" : this.device.state.battery < 41 ?
                        "battery_low" : this.device.state.battery < 71 ?
                            "battery_middle" : !this.device.state.battery ?
                                "battery_unknown" : "battery_high";
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.status-marker {
    align-items: center;
    display: inline-flex;

    .green-color,
    .red-color {
        height: 12px;
        width: 12px;
        border-radius: 6px;
    }

    .green-color {
        background: #42D829;
    }

    .red-color {
        background: #FF4F4F;
    }
}

.v-tooltip__content {
    background: linear-gradient(180deg, #FFF4BC 0%, rgba(255, 132, 132, 0.8) 100%);
    border-radius: 30px;
    padding: 16px;

    &.menuable__content__active {
        opacity: 1;

        &.arrow-down {
            overflow: inherit !important;
            z-index: 7;

            &::before {
                content: '';
                position: absolute;
                left: 50%;
                top: 100%;
                border: 5px solid #FF8484;
                border-color: #FF8484 transparent transparent transparent;
                opacity: 0.8;
            }
        }
    }
}
</style>